import clsx from 'clsx';
import React from 'react';
import { cva, cx } from 'cva';

const card = cva('card', {
  variants: {
    variant: {
      flat: [''],
      elevated: ['bg-white lg:drop-shadow-card'],
    },
    edge: {
      rounded: [''],
      square: [''],
      roundedTop: [''],
      roundedBottom: [''],
      roundedLeft: [''],
      roundedRight: [''],
    },
    edgeSize: {
      lg: [''],
      md: [''],
      none: [''],
    },
    padding: {
      md: ['p-6 lg:p-8'],
      none: [''],
    },
  },
  compoundVariants: [
    {
      edge: 'rounded',
      edgeSize: 'lg',
      className: 'lg:rounded-[0.625rem]',
    },
    {
      edge: 'roundedTop',
      edgeSize: 'lg',
      className: 'lg:rounded-t-[0.625rem]',
    },
    {
      edge: 'roundedBottom',
      edgeSize: 'lg',
      className: 'lg:rounded-b-[0.625rem]',
    },
    {
      edge: 'roundedLeft',
      edgeSize: 'lg',
      className: 'lg:rounded-l-[0.625rem]',
    },
    {
      edge: 'roundedRight',
      edgeSize: 'lg',
      className: 'lg:rounded-r-[0.625rem]',
    },
    {
      edge: 'rounded',
      edgeSize: 'md',
      className: 'lg:rounded-md',
    },
    {
      edge: 'roundedTop',
      edgeSize: 'md',
      className: 'lg:rounded-t-md',
    },
    {
      edge: 'roundedBottom',
      edgeSize: 'md',
      className: 'lg:rounded-b-md',
    },
    {
      edge: 'roundedLeft',
      edgeSize: 'md',
      className: 'lg:rounded-l-md',
    },
    {
      edge: 'roundedRight',
      edgeSize: 'md',
      className: 'lg:rounded-r-md',
    },
    {
      edge: 'square',
      edgeSize: 'none',
      className: 'rounded-none',
    },
  ],
  defaultVariants: {
    variant: 'elevated',
    edge: 'rounded',
    edgeSize: 'md',
    padding: 'md',
  },
});

function Card(props) {
  const {
    variant,
    edge,
    edgeSize,
    padding,
    children,
    className,
    style = {},
  } = props;

  const cardProps = {
    variant,
    edge,
    edgeSize,
    padding,
    className: cx('flex flex-col', className),
  };

  if (edge === 'square') {
    cardProps.edgeSize = 'none';
  }

  return (
    <div className={card(cardProps)} style={style}>
      {children}
    </div>
  );
}

export default Card;
